import { Section } from "../tools/section";
import { Swiper } from "swiper";
import { Scrollbar, Navigation } from "swiper/modules";
import AOS from 'aos';
import 'swiper/css/scrollbar';
import 'aos/dist/aos.css';

// Selectors
const SELECTOR_SECTION =          '[data-featured-articles]';
const SELECTOR_SWIPER_CONTAINER = '[data-swiper-container]';
const SELECTOR_SWIPER_SCROLLBAR =      '[data-swiper-scrollbar]';
const SELECTOR_SWIPER_NEXT =      '[data-swiper-next]';
const SELECTOR_SWIPER_PREV =      '[data-swiper-prev]';


export class FeaturedArticles extends Section {
  private swiperInstances: Map<string, Swiper> = new Map();
  private swiperContainer:HTMLElement|null;
  private scrollbarEl: HTMLElement | null = null;

  queryChildren(container: HTMLElement) {
    this.swiperContainer = container.querySelector(SELECTOR_SWIPER_CONTAINER);
    this.scrollbarEl = container.querySelector(SELECTOR_SWIPER_SCROLLBAR);
  }

  attachEvents() {
    if (this.swiperContainer) {
      this.initializeSwiper(this.swiperContainer);
    }
    AOS.init({ duration: 800, easing: 'ease-out', once: true });

    requestAnimationFrame(() => {
      AOS.refreshHard();
    });
  }

  detatchEvents(): void {}

  initializeSwiper(container: HTMLElement) {
    const swiper = new Swiper(container, {
      modules: [Scrollbar, Navigation],
      slidesPerView: 1.5,
      centeredSlides: true,
      keyboard: true,
      spaceBetween: 1,
      grabCursor: true,
      loop: true,
      touchMoveStopPropagation: true,
      breakpoints: {
        1100: {
          spaceBetween: 122,
          slidesPerView: 1.91,
        },
      },
      scrollbar: {
        el: this.scrollbarEl,
        draggable: true,
      },
      navigation: {
        nextEl: container.querySelector(SELECTOR_SWIPER_NEXT),
        prevEl: container.querySelector(SELECTOR_SWIPER_PREV),
      },
    });
    this.swiperInstances.set(container.getAttribute('data-swiper-container')!, swiper);
  }

}

Section.register(SELECTOR_SECTION, FeaturedArticles);